import React, { Component } from 'react'
import styled from "styled-components";
import BOT from "../../../../assets/imgs/bot.svg";

const CategoryWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
`;

const IndividualOffer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95px;
    padding: 10px 0px;
    cursor: pointer;
`;
const CategoryImg = styled.div`
    width: 50px;
    height: 50px;
`;
const CategoryTitle = styled.div`
    font-size: 14px;
    text-align:center;
`;


export default class OffersCategory extends Component {
    state={
        categories:[],
        itemsToShow: 0,
        expand: false,
    }
    componentDidMount(){
        let arr1=[...this.props.cardData].map((data,index)=>{
            return {...data};
          })
        let count= arr1.length<=6?arr1.length:6;
        this.setState({categories: arr1,itemsToShow:count});
    }
    handleView = () =>{
        let view =0;
        let catLength =this.state.categories.length;
        if(this.state.expand === true){
            view= catLength<=6?catLength:6;
        }else{
            view=catLength;
        }
        this.setState({expand:!this.state.expand,itemsToShow:view});
    }
    handleSubmit = (category) =>{
        let inputString = category + "<split>" + category;
        window["autosubmit"](inputString);
      //  console.log(inputString);
    }
    render() {
        return (
            <div className="disable-item">
                <CategoryWrapper>
                {this.state.categories.slice(0,this.state.itemsToShow).map((data,index)=>{
                    return (<IndividualOffer key={data.categoryNo} onClick={()=>{this.handleSubmit(data.title)}}>
                        {/* <CategoryImg onClick={()=>{this.handleSubmit(data.autosubmitQuestion)}}><img src={BOT} alt="image not fetched"/></CategoryImg> */}
                        
                    <img src={data.iconsLink}></img>
                    <CategoryTitle onClick={()=>{this.handleSubmit(data.title)}}>{data.title.replace(/&amp;/g,"&")}</CategoryTitle>
                    </IndividualOffer>);
                })}
                </CategoryWrapper>
                {this.state.categories.length>6?<div className="action-elem disable-item" onClick={this.handleView}>{this.state.expand?"Show less":"Show more"}</div>:null}
            </div>
        )
    }
}
